export default __webpack_public_path__ + "static/media/password protection.aeccc1b5.jpg";